import React from 'react';
import { X } from 'lucide-react';

interface TermsOfServiceProps {
  onClose: () => void;
  onAccept: () => void;
}

export default function TermsOfService({ onClose, onAccept }: TermsOfServiceProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6">
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-xl font-semibold">Terms of Service</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <div className="prose prose-sm max-h-96 overflow-y-auto mb-6">
          <h3>ClearCash Budget App - Terms of Service</h3>
          
          <h4>1. Acceptance of Terms</h4>
          <p>By accessing and using ClearCash (the "App"), you agree to comply with these Terms of Service (the "Terms"). If you do not agree with any of these Terms, please do not use the App.</p>
          
          <h4>2. Service Description</h4>
          <p>ClearCash is a budgeting application designed to assist users in managing their finances. While we strive to provide a reliable and secure service, ClearCash makes no guarantees as to the accuracy or availability of the information provided by the App.</p>
          
          <h4>3. Data Privacy and Security</h4>
          <p>ClearCash is committed to ensuring your privacy and the security of your financial data. We do not track or record any personal information, including budgeting details, and we do not collect any personal data for marketing, analysis, or other purposes.</p>
          <p>All user data is stored securely in an encrypted database, ensuring that it remains protected and confidential. No individual, including administrative staff or ClearCash employees, has access to user budget data or any personal information. This structure ensures that only the user can access their data, preserving both privacy and control.</p>
          
          <h4>4. Responsibility for Data Loss</h4>
          <p>ClearCash is not responsible for any lost data, whether caused by user error, software malfunction, or other technical issues. We recommend that users back up any critical financial information, as ClearCash does not store personal budget data that can be recovered by administrative staff in case of loss.</p>
          
          <h4>5. Limitation of Liability</h4>
          <p>ClearCash and its team will not be liable for any direct, indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the App, including, but not limited to, financial losses, data corruption, or other issues arising from use or malfunction.</p>
          
          <h4>6. Changes to Terms</h4>
          <p>ClearCash reserves the right to update or change these Terms at any time. We will notify users of any changes by updating the "Last Updated" date at the beginning of this document. Continued use of the App after changes signifies your acceptance of the new terms.</p>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Decline
          </button>
          <button
            onClick={onAccept}
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}